import React, { Component } from "react";
import { Segment, Grid, Table } from "semantic-ui-react";
import _ from "lodash";
import ReportSummary from "../ReportSummary";
import { getAllRows } from "../ReportElementHelper";
import PrintReportCaseHeader from "../PrintReportCaseHeader";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class BusinessBljReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.loadData(props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  onReportIndexChanged = (currentIndex) => {
    this.changeReport(currentIndex);
    const element = document.getElementById(`acc_${currentIndex}`);
    element.scrollIntoView();
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  loadData = (props) => {
    if (props.reportData !== undefined) {
      const repRecords = _.get(
        props.reportData,
        `${Object.keys(this.props.reportData)[0]}.record`
      );
      const accordionIndexes = [];
      _.forEach(repRecords, () => {
        accordionIndexes.push(false);
      });
      if (accordionIndexes.length > 0) accordionIndexes[0] = true;
      this.state = {
        activeIndex: 0,
        accordionIndexes,
      };
    }
  };

  handleClick = (e, index) => {
    this.changeReport(index);
  };

  changeReport = (index) => {
    const { activeIndex } = this.state;
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = false;
    });
    accordionIndexes[index] = !accordionIndexes[index];
    if (activeIndex !== index) {
      const newIndex = activeIndex === index ? -1 : index;
      this.setState({
        activeIndex: newIndex,
        accordionIndexes,
      });
    } else {
      this.setState({
        accordionIndexes,
      });
    }
  };

  render() {
    const records = [];
    const itemTitles = [];
    let actId;
    if (this.props.reportData !== undefined) {
      actId = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
      );

      _.forEach(
        _.get(
          this.props.reportData,
          `${Object.keys(this.props.reportData)[0]}.record`
        ),
        (record, index) => {
          const businessName = _.get(record, "businessName[0]._", "");
          itemTitles.push(businessName);
          const recs = [];
          getAllRows(record, recs, this.props, "", 1, undefined, true);
          const rows = [];
          rows.push(
            <Table.Row id={`row_${index}`} key={`row_${index}`}>
              <Table.Cell>
                <Table key={`blj_${index}`}>
                  <Table.Body>{recs}</Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
          //     records.push(
          //   <Accordion.Title
          //     className="report-name-header"
          //     active={this.state.accordionIndexes[index]}
          //     key={`report_acc_title_${index}`}
          //     onClick={e => this.handleClick(e, index)}
          //   >
          //     <Icon name="dropdown" />
          //     {businessName}
          //   </Accordion.Title>
          // );
          // records.push(
          //   <Accordion.Content
          //     key={`report_acc_content_${index}`}
          //     active={this.state.accordionIndexes[index]}
          //   >
          //     <Table key={`blj_${index}`}>
          //       <Table.Body>{recs}</Table.Body>
          //     </Table>
          //   </Accordion.Content>
          // );
          records.push(
            <SimpleAccordionContent
              {...this.props}
              name={businessName}
              rows={rows}
              key={`acc_${index}`}
              accId={`acc_${index}`}
            />
          );
        }
      );
    }

    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>
                  <PrintReportCaseHeader
                    {...this.props}
                    actId={actId}
                    onReportPrint={this.onReportPrint}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                activeSummaryIndex={this.state.activeIndex}
                itemTitles={itemTitles}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              {/* <Accordion fluid styled> */}
              {records}
              {/* </Accordion> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default BusinessBljReport;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessBljReport.js